/* eslint-disable prefer-named-capture-group */
/* eslint-disable require-unicode-regexp */

import {NinchatUserIdentities} from 'api/types/properties'
import {NinchatUsersStore} from 'api/types/store'

export const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const isEmail = (email: string) => email
    .toLowerCase()
    .match(emailPattern)

export const isProtectedEmailLoading = (member?: NinchatUsersStore[0]): boolean => !('user_identities' in (member ?? {}))

export const getProtectedEmail = (userIdentities?: NinchatUserIdentities): string => Object.entries(userIdentities?.email ?? {})
    .filter(([_, value]) => value?.public === true || value?.protected === true)
    .map(([key]) => key)
    .join(', ')
